import React, { useState } from "react";
import "./style.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/reset-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setMessage("Password reset instructions have been sent to your email.");
        setIsSubmitted(true);
      } else {
        const data = await response.json();
        setMessage(data.message || "Password reset failed.");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="forgot-password-box">
      <div className="forgot-password-content">
        <h2>Forgot Password</h2>
        {!isSubmitted ? (
          <form onSubmit={handleSubmit}>
            <label>
              Email:
              <input
                type="email"
                value={email}
                onChange={handleEmailChange}
                required
              />
            </label>
            <button type="submit">Reset Password</button>
            {message && <p className="error-message">{message}</p>}
          </form>
        ) : (
          <p>{message}</p>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
